import { OnInit, Input, Component } from '@angular/core';
import Product from 'src/app/model/product/product';
import { Adjustment } from 'src/app/model/project/adjustment';

@Component({
  selector: 'adjustment-product-summary',
  templateUrl: './adjustment-product-summary.component.html',
  styleUrls: ['./adjustment-product-summary.component.scss']
})
export class AdjustmentProductSummaryComponent implements OnInit {
  @Input()
  product: Product;

  @Input()
  index: number;

  @Input()
  subproject: Adjustment;

  @Input()
  multipleProducts: boolean;

  @Input()
  client = false;

  ngOnInit() {}
}
